import { render, staticRenderFns } from "./InteractionAdsVast.vue?vue&type=template&id=027faed4&scoped=true"
import script from "./InteractionAdsVast.vue?vue&type=script&lang=js"
export * from "./InteractionAdsVast.vue?vue&type=script&lang=js"
import style0 from "./InteractionAdsVast.vue?vue&type=style&index=0&id=027faed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027faed4",
  null
  
)

export default component.exports